import React, { useContext, useEffect, useRef } from "react";
import DataTable from "react-data-table-component";
import RecordNotFound from "../../../components/Reusable/RecordNotFound";
import Loading from "../../../components/Loading";
import Pagination from "../../../components/Pagination";
import { FaEye } from "react-icons/fa";
import ViewCandidateDetail from "./ViewCandidateDetail";
import { DATE_FORMAT_DISPLAY, HYBRID, ON_SITE, POPUP_LARGE, S3_BUCKET_LINK } from "../../../constants";
import { BasePopupContext } from "../../../components/BasePopup";
import { DateTime } from "luxon";
import { customStyles } from "../../../utils";

const TableComponent = ({
    data,
    loading,
    count,
    perPage,
    currentPage,
    setCurrentPage,
    offset,
    getOnlyTableData,
    loadingOnlyTable,
    errorOnlyTable,
    error
}) => {
    const { setPopup } = useContext(BasePopupContext)

    useEffect(() => {
        getOnlyTableData();
    }, [currentPage])


    const openPopup = (row) => {
        const popup = {
            hideDefaultClose: false,
            component: <ViewCandidateDetail row={row} />,
            visible: true,
            // heading: `${row.first_name +" " + row.last_name}`,
            heading: "Details",
            contained: false,
            size: POPUP_LARGE,
            contained: true
        }
        setPopup(popup)
    }


    const columns = [
        {
            name: "View",
            selector: "",
            width: "70px",
            cell: (row) =>
                <div className="" >
                    <FaEye onClick={() => openPopup(row)} className="transition-transform cursor-pointer text-xl transform" />
                </div>,
        },
        {
            name: "Title",
            selector: "title",
            width: "250px",
            cell: (row) => <div className='line-clamp-2'>{row.job_title ? row.job_title : "Spontaneous Application"}</div>,
        },
        {
            name: "First Name",
            selector: "color",
            width: "120px",
            cell: (row) => <>
                <div>
                    {row.first_name}
                </div>
            </>,
        },
        {
            name: "Last Name",
            selector: "color",
            width: "120px",
            cell: (row) => <>
                <div>
                    {row.last_name}
                </div>
            </>,
        },
        {
            name: "Email",
            selector: "color",
            width: "240px",
            cell: (row) => <>
                <div>
                    {row.email}
                </div>
            </>,
        },
        {
            name: "Department",
            selector: "color",
            width: "210px",
            cell: (row) => <>
                <div>
                    {row?.department?.title}
                </div>
            </>,
        },
        {
            name: "Apply On",
            selector: "applied_on",
            width: "120px",
            cell: (row) => <div>{DateTime.fromISO(row.created_on).toFormat(DATE_FORMAT_DISPLAY)}</div>,
        },
        {
            name: "Location",
            selector: "location",
            width: "190px",
            cell: (row) => <div className='w-full'>{row.job_location ? row.job_location : <p className='w-full text-center'>-</p>}</div>,
        },
        {
            name: "Type",
            selector: "job_type",
            width: "150px",
            cell: (row) => (
                <div>
                    {row.job_type === ON_SITE ? "Onsite" : row.job_type === HYBRID ? "Hybrid" : "Remote"}
                </div>
            ),
        },
        // {
        //     name: "Action",
        //     selector: "action",
        //     width: "100px",
        //     cell: (row) => (
        //         <div>
        //             <Actions data={row} refreshListing={refreshListing} />
        //         </div>
        //     ),
        // },
        {
            name: "Resume",
            selector: "",
            width: "200px",
            cell: (row) =>
                <div>
                    <a href={row.resume} target='_blank'>
                        <div className='btn btn-small btn-primary cursor-pointer'>
                            Open Resume
                        </div>
                    </a>
                </div>,
        },

    ];

    return (
        loadingOnlyTable && !errorOnlyTable ?
            <Loading />
            :
            !loadingOnlyTable && errorOnlyTable ?
                <p className='text-red-500 text-center'>{error}</p>
                :
                <>
                    <DataTable
                        noDataComponent={
                            <div className="w-full">
                                <RecordNotFound />
                            </div>
                        }
                        columns={columns}
                        data={data}
                        highlightOnHover={true}
                        striped={true}
                        customStyles={customStyles}
                        progressComponent={<Loading />}
                        progressPending={loading}
                    />

                    <div className="mt-16 flex justify-end text-center">
                        <Pagination
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            perPage={perPage}
                            offset={offset}
                            count={count}
                            total_pages={Math.ceil(count / perPage)}
                        />
                    </div>
                </>
    );
};

export default TableComponent;